import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

/**
 * props:
 * - to: endereço do link
 * - text: texto do item
 * - tooltip: texto do tooltip (opcional)
 * - children: tag SVG
 * - onClick: um callback de click (quando necessário)
 */
function SideBarItem(props) {
    const liRef = useRef(null);
    const ttRef = useRef(null);

    useEffect(() => {
        if (!props.tooltip || !liRef.current || !window.bootstrap) return;
        ttRef.current = new window.bootstrap.Tooltip(liRef.current, {
            placement: 'right',
            trigger: 'hover',
            title: props.tooltip
        });
        return () => {
            if (ttRef.current) { ttRef.current.dispose(); ttRef.current = null; }
        };
    }, [props.tooltip]);

    function handleClick(e) {
        if (ttRef.current) ttRef.current.hide();
        if (props.onClick) props.onClick(e);
    }

    function getClassName(itemName) {
        return window.location.pathname === itemName ? 'nav-item active' : 'nav-item';
    }

    return (
        <li ref={liRef} className={getClassName(props.to)}>
            <Link to={props.to} className="nav-link" onClick={handleClick}>
                <span className="sidebar-icon">
                    {props.children}
                </span>
                <span className="sidebar-text">{props.text}</span>
            </Link>
        </li>
    );
}

export default SideBarItem;
